import { GET_REGLA_NEGOCIO_LIST, GET_REGLA_NEGOCIO_DETAIL, PUT_REGLA_NEGOCIO_EDIT, POST_REGLA_NEGOCIO_CREATE, DELETE_REGLA_NEGOCIO, ACTIVAR_REGLA_NEGOCIO} from "./ReglaNegocioAction";

let initialState = {
    getReglaNegocioList:           false,
    errorReglaNegocioList:         false,
    getReglaNegocioDetail:         false,
    errorReglaNegocioDetail:       false,
    getResponDataReglaNegocio:     false,
    errorResponDataReglaNegocio:   false,
    getResponDataReglaNegocioC:    false,
    errorResponDataReglaNegocioC:  false,
    getReglaNegocioBorrar:         false,
    errorReglaNegocioBorrar: false,
    getReglaNegocioActivar: false,
    errorReglaNegocioActivar: false,
};

const ReglaNegocioReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_REGLA_NEGOCIO_LIST:
            return {
                ...state,
                getReglaNegocioList: action.payload.data,
                errorReglaNegocioList: action.payload.errorMessage,
            };

        case GET_REGLA_NEGOCIO_DETAIL:

            return {
                ...state,
                getReglaNegocioDetail: action.payload.data,
                errorReglaNegocioDetail: action.payload.errorMessage,
            };

        case PUT_REGLA_NEGOCIO_EDIT:
            return {
                ...state,
                getResponDataReglaNegocio: action.payload.data,
                errorResponDataReglaNegocio: action.payload.errorMessage,
            };

        case POST_REGLA_NEGOCIO_CREATE:
            return {
                ...state,
                getResponDataReglaNegocioC: action.payload.data,
                errorResponDataReglaNegocioC: action.payload.errorMessage,
            };

        case DELETE_REGLA_NEGOCIO:
            return {
                ...state,
                getReglaNegocioBorrar: action.payload.data,
                errorReglaNegocioBorrar: action.payload.errorMessage,
            };
            
        case ACTIVAR_REGLA_NEGOCIO:
            return {
                ...state,
                getReglaNegocioActivar: action.payload.data,
                errorReglaNegocioActivar: action.payload.errorMessage,
            };


        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default ReglaNegocioReducer;